import FileUpload from './FileUpload';

export default async function uploadAsset(
  file: File,
  opts: {onProgress?: (pct: number) => void; signal?: AbortSignal} = {}
): Promise<{sourceUrl: string}> {
  const extension = file.name.includes('.')
    ? file.name.split('.').pop()!.toLowerCase()
    : file.type.split('/')[1];
  const {url, key} = await FileUpload.getPresignedUploadUrl({
    bucket: 'photo_submissions',
    extension,
  });
  await FileUpload.upload({
    file,
    presignedUploadUrl: url,
    onProgress: opts.onProgress,
    signal: opts.signal,
  });
  return {sourceUrl: key};
}
